import { useState, useEffect } from "react";
import axios from "../../utils/axiosInstance";
import FileInput from "../../components/edittext/fileInput/fileInput";

const tabs = ["general", "store", "payment", "seo", "security"];

const Settings = () => {
  const [activeTab, setActiveTab] = useState("general");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [docFile, setDocFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/settings");
      setData(res.data);
    } catch (err) {
      console.error("Error loading settings", err);
    } finally {
      setLoading(false);
    }
  };
  const handleDocSelect = (e) => {
    setDocFile(e.target.files[0]);
  };

  const handleUploadDoc = async (type) => {
    if (!docFile) {
      alert("یک فایل انتخاب کنید");
      return;
    }

    try {
      setUploading(true);
      const fd = new FormData();
      fd.append("image", docFile);
      fd.append("type", type); // 👈 اضافه شد

      const res = await axios.post("/settings/upload-image", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("آپلود شد ");
      // داده‌ها رو ریفرش کن تا تصویر جدید نمایش داده بشه
      fetchSettings();
    } catch (err) {
      console.error("upload doc", err);
      alert("خطا در آپلود");
    } finally {
      setUploading(false);
    }
  };

  const handleChange = (section, field, value, subField = null) => {
    setData((prev) => ({
      ...prev,
      [section]: {
        ...prev[section],
        [subField || field]: subField
          ? { ...prev[section][subField], [field]: value }
          : value,
      },
    }));
  };

  const handleSave = async (section) => {
    try {
      setSaving(true);
      await axios.put(`/settings/${section}`, data[section]);
      alert("Settings saved successfully!");
    } catch (err) {
      console.error("Error saving settings", err);
    } finally {
      setSaving(false);
    }
  };

  if (loading || !data) return <p>Loading settings...</p>;

  return (
    <div className="container py-4">
      <h2 className="mb-4">Site Settings</h2>

      {/* Nav Tabs */}
      <ul className="nav nav-tabs mb-3">
        {tabs.map((tab) => (
          <li className="nav-item" key={tab}>
            <button
              className={`nav-link ${activeTab === tab ? "active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
            </button>
          </li>
        ))}
      </ul>

      <div className="card p-4 shadow-sm">
        {activeTab === "general" && (
          <>
            <h5>General Settings</h5>
            <div className="row g-3 mt-2">
              <div className="col-md-6">
                <label className="form-label">Site Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={data.general.siteName}
                  onChange={(e) =>
                    handleChange("general", "siteName", e.target.value)
                  }
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Contact Email</label>
                <input
                  type="email"
                  className="form-control"
                  value={data.general.contactEmail || ""}
                  onChange={(e) =>
                    handleChange("general", "contactEmail", e.target.value)
                  }
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Phone Number</label>
                <input
                  type="text"
                  className="form-control"
                  value={data.general.phoneNumber || ""}
                  onChange={(e) =>
                    handleChange("general", "phoneNumber", e.target.value)
                  }
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Address</label>
                <input
                  type="text"
                  className="form-control"
                  value={data.general.address || ""}
                  onChange={(e) =>
                    handleChange("general", "address", e.target.value)
                  }
                />
              </div>
            </div>
            <div className="col-md-6">
              <FileInput
                bsize="2"
                bcolor="primary"
                margin="2"
                bgcolor="white"
                textcolor="black"
                handleFileChange={handleDocSelect}
                handleUpload={() => handleUploadDoc("logo")}
              />

              {data.general.siteLogo && (
                <img
                  src={data.general.siteLogo}
                  alt="Site Logo"
                  style={{
                    maxHeight: "60px",
                    marginTop: "8px",
                    borderRadius: "6px",
                    border: "1px solid #ddd",
                    padding: "4px",
                  }}
                />
              )}
            </div>

            <div className="col-md-6">
              <FileInput
                bsize="2"
                bcolor="primary"
                margin="2"
                bgcolor="white"
                textcolor="black"
                handleFileChange={handleDocSelect}
                handleUpload={() => handleUploadDoc("favicon")}
              />

              {data.general.favicon && (
                <img
                  src={data.general.favicon}
                  alt="Favicon"
                  style={{
                    maxHeight: "40px",
                    marginTop: "8px",
                    borderRadius: "6px",
                    border: "1px solid #ddd",
                    padding: "4px",
                  }}
                />
              )}
            </div>
          </>
        )}

        {activeTab === "store" && (
          <>
            <h5>Store Settings</h5>
            <div className="row g-3 mt-2">
              <div className="col-md-4">
                <label className="form-label">Currency</label>
                <input
                  type="text"
                  className="form-control"
                  value={data.store.currency}
                  onChange={(e) =>
                    handleChange("store", "currency", e.target.value)
                  }
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Tax Rate (%)</label>
                <input
                  type="number"
                  className="form-control"
                  value={data.store.taxRate}
                  onChange={(e) =>
                    handleChange("store", "taxRate", e.target.value)
                  }
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Default Shipping Cost</label>
                <input
                  type="number"
                  className="form-control"
                  value={data.store.defaultShippingCost}
                  onChange={(e) =>
                    handleChange("store", "defaultShippingCost", e.target.value)
                  }
                />
              </div>
            </div>
          </>
        )}

        {activeTab === "payment" && (
          <>
            <h5>Payment Settings</h5>
            <div className="row g-3 mt-2">
              <div className="col-md-6">
                <label className="form-label">Available Methods</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="e.g. online, cod"
                  value={data.payment.methods.join(", ")}
                  onChange={(e) =>
                    handleChange(
                      "payment",
                      "methods",
                      e.target.value.split(",")
                    )
                  }
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Gateways</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="e.g. paypal, stripe"
                  value={data.payment.gateways.join(", ")}
                  onChange={(e) =>
                    handleChange(
                      "payment",
                      "gateways",
                      e.target.value.split(",")
                    )
                  }
                />
              </div>
            </div>
          </>
        )}

        {activeTab === "seo" && (
          <>
            <h5>SEO Settings</h5>
            <div className="row g-3 mt-2">
              <div className="col-md-6">
                <label className="form-label">Default Title</label>
                <input
                  type="text"
                  className="form-control"
                  value={data.seo.defaultTitle}
                  onChange={(e) =>
                    handleChange("seo", "defaultTitle", e.target.value)
                  }
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Meta Description</label>
                <input
                  type="text"
                  className="form-control"
                  value={data.seo.defaultMetaDescription || ""}
                  onChange={(e) =>
                    handleChange(
                      "seo",
                      "defaultMetaDescription",
                      e.target.value
                    )
                  }
                />
              </div>
            </div>
          </>
        )}

        {activeTab === "security" && (
          <>
            <h5>Security Settings</h5>
            <div className="row g-3 mt-2">
              <div className="col-md-6">
                <label className="form-label">Max Login Attempts</label>
                <input
                  type="number"
                  className="form-control"
                  value={data.security.maxLoginAttempts}
                  onChange={(e) =>
                    handleChange("security", "maxLoginAttempts", e.target.value)
                  }
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Token Expiry (hours)</label>
                <input
                  type="number"
                  className="form-control"
                  value={data.security.tokenExpiryHours}
                  onChange={(e) =>
                    handleChange("security", "tokenExpiryHours", e.target.value)
                  }
                />
              </div>
            </div>
          </>
        )}

        <div className="mt-4 text-end">
          <button
            className="btn btn-primary px-4"
            onClick={() => handleSave(activeTab)}
            disabled={saving}
          >
            {saving ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Settings;
